import React from 'react';

interface ReportEditLayoutProps {
  children: React.ReactNode;
}

export const ReportEditLayout: React.FC<ReportEditLayoutProps> = ({ children }) => (
  <div className="min-h-screen bg-white">
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-6xl mx-auto">{children}</div>
    </div>
  </div>
);
